import { render, staticRenderFns } from "./PCDetail.vue?vue&type=template&id=2522ea3e&scoped=true"
import script from "./PCDetail.vue?vue&type=script&lang=js"
export * from "./PCDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2522ea3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2522ea3e')) {
      api.createRecord('2522ea3e', component.options)
    } else {
      api.reload('2522ea3e', component.options)
    }
    module.hot.accept("./PCDetail.vue?vue&type=template&id=2522ea3e&scoped=true", function () {
      api.rerender('2522ea3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/PCDetail.vue"
export default component.exports